<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('quarterly-data-report-manage')" v-if="permissionCodes.indexOf('042001000') !== -1">
        <i class="el-icon-damai-ic_niandushujushangbao"></i>
        <span slot="title">季度数据上报</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('annual-data-report-manage')" v-if="permissionCodes.indexOf('042002000') !== -1">
        <i class="el-icon-damai-ic_jidushujushangbao"></i>
        <span slot="title">年度数据上报</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('political-communication-log')" v-if="permissionCodes.indexOf('042004000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  "1": ["quarterly-data-report-manage", "quarterly-data-report-modify"],
  "2": ["annual-data-report-manage", "annual-data-report-modify"],
  "3": ["political-communication-log"]
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/PoliticalCommunication/PoliticalCommunicationNav.vue